export const emptyInputLength = 0;
export const shortPostalCodeLength = 5;
export const fullPostalCodeLength = 10;
